module.exports = __webpack_public_path__ + "img/04.e1e36df0.png";